import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import type { Extensions } from '@tiptap/core';

export function buildExtensions(opts: { placeholder?: string }): Extensions {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      history: { depth: 50 },
    }),
    Placeholder.configure({
      placeholder: opts.placeholder ?? '',
      showOnlyWhenEditable: true,
      emptyEditorClass: 'rte-richtext-empty',
    }),
  ];
}
